import { ImmutableVector3 } from '@modugen/ui-toolkit'

/** Rotation snaps to multiples of this angle (90°). */
export const ROTATION_SNAP_RAD = Math.PI / 2

/** Magnetic drag-snap tolerance around a 90° multiple (~8°). */
export const ROTATION_SNAP_TOLERANCE_RAD = (8 * Math.PI) / 180

/**
 * How close (rad) the frame's orientation must be to a 90° multiple for the "snap to right angle"
 * HUD action to appear (~15°).
 */
export const RIGHT_ANGLE_SNAP_THRESHOLD_RAD = (15 * Math.PI) / 180

/**
 * Below this offset (rad, ~0.1°) the frame is treated as already square, so the "snap to right
 * angle" action hides (there is nothing left to snap).
 */
export const RIGHT_ANGLE_MIN_OFFSET_RAD = (0.1 * Math.PI) / 180

/** Rotate `p` around `center` in the XY-plane (keeping its z) by `angle` radians. */
export const rotateAroundZ = (
  p: ImmutableVector3,
  center: { x: number; y: number },
  angle: number,
): ImmutableVector3 => {
  const cos = Math.cos(angle)
  const sin = Math.sin(angle)
  const dx = p.x - center.x
  const dy = p.y - center.y
  return new ImmutableVector3(center.x + dx * cos - dy * sin, center.y + dx * sin + dy * cos, p.z)
}

/** Angle (rad) of the frame's X axis (first→second) relative to the global X axis. */
export const getFrameAxisAngle = (
  first: { x: number; y: number },
  second: { x: number; y: number },
): number => Math.atan2(second.y - first.y, second.x - first.x)

/** Signed offset (rad) from `axisAngle` to the nearest 90° multiple. */
export const offsetToNearestRightAngle = (axisAngle: number): number => {
  const nearest = Math.round(axisAngle / ROTATION_SNAP_RAD) * ROTATION_SNAP_RAD
  return axisAngle - nearest
}
